import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseHttpResponse, ListHttpResponse } from '../models/core.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
  

export class HelpService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string,
  ) { }  

  public getHelp(path: string, lang: string) {
    return this.http.get(`${this.apiUrl}help/get-help?path=${path}&language=${lang}`, { responseType: 'text' });
  }
}